$('.colors .dot').on('click', function() {
    let imgurl = this.firstElementChild.firstElementChild.innerHTML;
    $(this).closest('.topBlock').find('.imgContainer').css('backgroundImage', 'url(' + imgurl + ')');
    // console.log(imgurl);
});



// WEBPACK FOOTER //
// ./src/includes/blocks/catalog/catalog.js